import { _ep8, _mw0, command } from "../commandBuilder";
import { ListObjectsV2$ } from "../schemas/schemas_0";
export class ListObjectsV2Command extends command(_ep8, _mw0, "ListObjectsV2", ListObjectsV2$) {
}
